module.exports = __webpack_public_path__ + "static/hackathon-partner-a2c4be29316126175463c6b04b302f42.jpg";